import React from 'react';

import { useOpenDrawer } from '../../hooks/drawer';
import { useLocalization } from '../../providers/LocaleProvider';
import { BaseLabel } from '../BaseLabel';

interface SponsoredLabelProps {
  owner: string;
}

export const SponsoredLabel = ({ owner }: SponsoredLabelProps) => {
  const { r, t } = useLocalization();

  const openDrawer = useOpenDrawer({
    title: t('h24_product_card_sponsored'),
    html: r.t('h24_product_card_sponsored_content', { sellerName: owner }),
  });

  return (
    <BaseLabel ariaLabel={t('h24_product_card_sponsored_label')} onClick={openDrawer}>
      {t('h24_product_card_sponsored')}
    </BaseLabel>
  );
};
